<template>
    <div>
        <div class="TTL-dialog">
        <el-dialog v-model="param.view" title="新增 / 编辑医院" width="25%" :before-close="closeBefore">
            <el-form :model="form" align="center" v-loading="param.loading">
                <el-form-item>
                    <el-input v-model="param.name" placeholder="请填写医院名称" round size="large" prefix-icon="School" clearable/>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="param.address" placeholder="请填写医院位置" round size="large" prefix-icon="Location" clearable/>
                </el-form-item>
            </el-form>
            <div class="TTL-footer">
                <el-button type="warning" size="large" round @click="savehospital">保存</el-button>
                <el-button size="large" round @click="closeBefore">取消</el-button>
            </div>
        </el-dialog>    

        </div>
    </div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
export default {
    props: ['value','data'],
    data() {
        return {
            
            param: {
                view:false,
                id:'',
                name:'',
                address:''
            },

        }
    },

    watch: {
        value(val) {
            if(val) {
                this.param.view=true;
                this.resetparam(); //重置提交数据
                this.param.id=this.data.id > 0 ? this.data.id : 0;
                this.param.name=this.data.name!='' ? this.data.name : '';
                this.param.address=this.data.address!='' ? this.data.address : '';
            }
        },
    },

    mounted() {
        
    },

    methods: {


        /** 新增/编辑医院 **/
        savehospital() {
            this.param.loading=true;
            INTERFACE_MODEL_GENEALOGY.ADD_OR_EDIT_HOSPITAL(this.param).then((res) => {
                this.param.loading=false;
                if(res.status > 0) return false;
                this.closeBefore(); //关闭当前窗口
            });
        },


        /**
         * 重置提交数据
        */
        resetparam() {
            this.param.id=0;
            this.param.name='';
            this.param.address='';
        },


        /**
         * 关闭窗口
        */
        closeBefore() {
            this.param.view=false;
            this.$emit('hospitalfinish');
        },

    },

}
</script>
<style scoped>
.TTL-dialog {text-align:left !important;}
.TTL-setting-image-detail {width:80px;height:80px;text-align:center;margin:0 auto;}
.TTL-setting-image-detail .el-image {width:80px;height:80px;border-radius:50%;}
</style>